import { render, staticRenderFns } from "./ReplacementModalForm.vue?vue&type=template&id=2f42bc1e&"
import script from "./ReplacementModalForm.vue?vue&type=script&lang=js&"
export * from "./ReplacementModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementModalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f42bc1e')) {
      api.createRecord('2f42bc1e', component.options)
    } else {
      api.reload('2f42bc1e', component.options)
    }
    module.hot.accept("./ReplacementModalForm.vue?vue&type=template&id=2f42bc1e&", function () {
      api.rerender('2f42bc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/CustomerRequest/ReplacementModalForm.vue"
export default component.exports